import React from "react";
import logo from './testerly-logo.svg';
import Image from 'react-bootstrap/Image'
import './Logo.css';

const Logo = () => {
  return (
      <div className="logo-container">
          <Image className="testerly-logo-image" src={logo} />
          <div className="testerly-logo-text">
              Testerly
          </div>
      </div>
  );
}

export default Logo;